module.exports = __webpack_public_path__ + "static/logo-6132c1ad8870ccd5bace6059f9c3c70d.png";